<template>
    <div class="parceriasPage">

        <div class="vx-row">
            <div class="vx-col w-full md:w-2/5 lg:w-1/4 rounded-lg">
                <vx-card class="mb-5">
                    <h4>{{ $t('Categorias') }}</h4>
                    <ul class="faq-topics mt-4">
                        <li v-for="category in categories" :key="category.partner_category_id" class="p-2 font-medium flex items-center" :class="{'backLightGreen': category.selected == 1}" @click="selectFilter(category, 'categories')">
                            <div class="h-3 w-3 rounded-full mr-2" :style="'background-color:' + category.color"></div>
                            <span class="cursor-pointer" :class="{'bolding': (category.selected == 1 && category.partner_category_id != 0)}">{{ category.name }}</span>
                        </li>
                    </ul>
                </vx-card>
                <vx-card>
                    <h4>{{ $t('Zonas') }}</h4>
                    <ul class="faq-topics mt-4">
                        <li v-for="local in locals" :key="local.partner_local_info_id" class="p-2 font-medium flex items-center" :class="{'backLightGreen': local.selected == 1}" @click="selectFilter(local, 'locals')">
                            <div class="h-3 w-3 rounded-full mr-2" :style="'background-color:' + local.color"></div>
                            <span class="cursor-pointer" :class="{'bolding': (local.selected == 1 && local.partner_local_info_id != 0)}">{{ local.name }}
                            </span>
                        </li>
                    </ul>
                </vx-card>
            </div>

            <div class="vx-col w-full md:w-3/5 lg:w-3/4 mt-12 md:mt-0">
                <vs-input placeholder="Search" v-model="searchQuery" icon-pack="feather" icon="icon-search" size="large" class="w-full mb-6" icon-no-border />
                <vs-collapse accordion type="margin" class="p-0">
                    <vs-collapse-item v-for="(par, index) in filteredFaq" class="faq-bg rounded-lg" :class="{'mt-0': !index}" :key="par.partner_id">
                        <div slot="header">
                            <h5>{{ par.name }}</h5>
                            <p class="dataTitulo">{{ formateDate(par.partner.created_date) }}</p>
                        </div>
                        <img class="mb-6" v-if="par.partner.logo_path != null" :src="par.partner.logo_path" alt="Partner Logo">
                        <QuillPresentInfo v-bind:info="par.description" v-bind:cssClass="['mt10mb20', 'pdl-zero', 'pdr-zero']"></QuillPresentInfo>
                        <p>
                            <b>{{ $t('Data_de_Validade') }}:</b> {{ getDataValidade(par.partner.expiration_date) }}
                        </p>
                        
                        <div class="w-2/3 float-right vx-col mb-3" v-if="par.file.length > 0">
                            <vx-tooltip :text="file.file_name" class="float-right" v-for="(file, index) in par.file" :key="index">
                                    <vs-button icon-pack="feather" :href="file.file_path" target="_blank" radius icon="icon-file-text" class="ml-2 lg:ml-4 float-right mb5"></vs-button>
                            </vx-tooltip>
                        </div>
                    </vs-collapse-item>
                </vs-collapse>

            </div>
        </div>
        
    </div>

</template>

<script>

    import QuillPresentInfo from '@/views/components/QuillPresentInfo.vue'
    import moment from 'moment';

    export default {
        data(){
            return {
                searchQuery: '',
                filterCategory: '0',
                filterLocal: '0',
                categories: [],
                locals: [],
                parcerias: [],
            };
        },
        methods: {
            getList() {
                this.$vs.loading();
                this.$api({
                    method: 'get',
                    url: '/myvilagale/parcerias/getList',
                    params: {
                        token: localStorage.getItem('usertoken'),
                        language: this.$i18n.locale.toUpperCase(),
                        show: true,
                    },
                })
                .then((res) => {
                    this.parcerias = res.data;
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                })
                .then((res) => {
                    this.getCategories();
                });
            },

            getCategories() {
                this.$api({
                    method: 'get',
                    url: '/myvilagale/parcerias/getCategories',
                    params: {
                        token: localStorage.getItem('usertoken'),
                        language: this.$i18n.locale.toLowerCase()
                    },
                })
                .then((res) => {
                    this.categories = [{
                        partner_category_id: '0',
                        name: this.$t('Todas'),
                        color: '#A0A0A0',
                        selected: 1,
                    }];
                    let cat = res.data.map(function(value){
                        value.selected = 0;
                        return value;
                    });
                    for (let i = 0; i < cat.length; i++) {
                        this.categories.push(cat[i]);
                    }
                    this.getLocals();
                    this.$vs.loading.close();
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },
            getLocals() {
                this.$vs.loading();
                this.$api({
                    method: 'get',
                    url: '/myvilagale/parcerias/getLocals',
                    params: {
                        token: localStorage.getItem('usertoken'),
                    },
                })
                .then((res) => {
                    this.locals = [{
                        partner_local_info_id: '0',
                        name: this.$t('Todas'),
                        color: '#A0A0A0',
                        selected: 1,
                    }];
                    let loc = res.data.map(function(value){
                        value.selected = 0;
                        return value;
                    });
                    for (let i = 0; i < loc.length; i++) {
                        this.locals.push(loc[i]);
                    }
                    this.$vs.loading.close();
                })
                .catch((err) => {
                    this.notify(err.response.data.message, 'red', 10);
                    this.$vs.loading.close();
                });
            },
            getDataValidade(dataValidade){
                return dataValidade == null ? 'Sem Termo' : dataValidade.slice(0, 10);
            },
            formateDate(date) {
                moment.locale('pt');
                let new_date = moment(date).format('L LT');
                return new_date; 
            },
            selectFilter(element, type){
                for (let i = 0; i < this[type].length; i++) {
                    this[type][i]['selected'] = 0;
                }
                element['selected'] = 1;
                if(type == 'categories'){
                    this.filterCategory = element.partner_category_id;
                }else{
                    this.filterLocal = element.partner_local_info_id;
                }
                
            },
        },
        created(){
            this.getList();
        },
        computed: {
            filteredFaq () {

                let that = this;
                if(this.searchQuery == '' && this.filterCategory == 0 && this.filterLocal == 0){
                    return this.parcerias;
                }else if(this.searchQuery != '' && this.filterCategory == 0 && this.filterLocal == 0){
                    return this.parcerias.filter(function(el) {
                        return (el.name.toLowerCase().trim().indexOf(that.searchQuery.toLowerCase().trim()) > -1 ||
                        el.description.toLowerCase().trim().indexOf(that.searchQuery.toLowerCase().trim()) > -1)
                    })
                }else if(this.searchQuery == '' && this.filterCategory != 0 && this.filterLocal == 0){
                    return this.parcerias.filter(function(el) {
                        return el.partner.partner_category_id == that.filterCategory;
                    })
                }else if(this.searchQuery == '' && this.filterCategory == 0 && this.filterLocal != 0){
                    return this.parcerias.filter(function(el) {
                        if(el.partner.local.length > 0){
                            el.hasFilterLocal = 0;
                            for (let i = 0; i < el.partner.local.length; i++) {
                                if(el.partner.local[i].info.partner_local_info_id == that.filterLocal){
                                    el.hasFilterLocal = 1;
                                }
                            }
                            return el.hasFilterLocal == 1;
                        }
                    })
                }else if(this.searchQuery != '' && this.filterCategory != 0 && this.filterLocal == 0){
                    return this.parcerias.filter(function(el) {
                        return (el.partner.partner_category_id == that.filterCategory && 
                        (el.name.toLowerCase().trim().indexOf(that.searchQuery.toLowerCase().trim()) > -1 ||
                        el.description.toLowerCase().trim().indexOf(that.searchQuery.toLowerCase().trim()) > -1))
                    })
                }else if(this.searchQuery != '' && this.filterCategory == 0 && this.filterLocal != 0){
                    return this.parcerias.filter(function(el) {
                        if(el.partner.local.length > 0){
                            el.hasFilterLocal = 0;
                            for (let i = 0; i < el.partner.local.length; i++) {
                                if(el.partner.local[i].info.partner_local_info_id == that.filterLocal){
                                    el.hasFilterLocal = 1;
                                }
                            }
                            return el.hasFilterLocal == 1 &&
                                (el.name.toLowerCase().trim().indexOf(that.searchQuery.toLowerCase().trim()) > -1 ||
                                el.description.toLowerCase().trim().indexOf(that.searchQuery.toLowerCase().trim()) > -1);
                        }
                    })
                }else if(this.searchQuery == '' && this.filterCategory != 0 && this.filterLocal != 0){
                    return this.parcerias.filter(function(el) {
                        if(el.partner.local.length > 0){
                            el.hasFilterLocal = 0;
                            for (let i = 0; i < el.partner.local.length; i++) {
                                if(el.partner.local[i].info.partner_local_info_id == that.filterLocal){
                                    el.hasFilterLocal = 1;
                                }
                            }
                            return el.hasFilterLocal == 1 && el.partner.partner_category_id == that.filterCategory;
                        }
                    })
                }else{
                    return this.parcerias.filter(function(el) {
                        if(el.partner.local.length > 0){
                            el.hasFilterLocal = 0;
                            for (let i = 0; i < el.partner.local.length; i++) {
                                if(el.partner.local[i].info.partner_local_info_id == that.filterLocal){
                                    el.hasFilterLocal = 1;
                                }
                            }
                            return el.hasFilterLocal == 1 && el.partner.partner_category_id == that.filterCategory &&
                                (el.name.toLowerCase().trim().indexOf(that.searchQuery.toLowerCase().trim()) > -1 ||
                                el.description.toLowerCase().trim().indexOf(that.searchQuery.toLowerCase().trim()) > -1);
                        }
                    })
                }
            }
        },
        watch: {
            '$i18n.locale': function(new_val, old_val){
                this.getList();
            },
        },
        components: {
            QuillPresentInfo,
        },
    }
</script>

<style scoped>

    #sticker-win-wrapper {
        /*position: relative;
        float: right;*/
        /*z-index: 100;*/
        /*right: 80px;
        margin-top: -65px;*/
        background: white;
        border: 7px solid #319CA6;
        transform: rotate(14deg);
        /* padding: 7px; */
        border-radius: 100px;
        width: 200px;
        height: 200px;
    }
    #sticker-win {
        position: relative;
        /*display: table;*/
        /*font-family: 'titilliumtext_bold';*/
        width: 175px;
        height: 175px;
        background: white;
        text-align: center;
        font-size: 32px;
        border-radius: 100px;
        border: 4px dashed #319CA6;
        color: #FFBB4C;
        font-weight: bold;
        line-height: 35px;
        cursor: default;
        left: 6px;
        top: 6px;
    }
    #sticker-win div {
        display: grid;
        padding-top: 44px;
        letter-spacing: -1px;
    }
    #sticker-win span:first-child {
        color: #6EC9C2;
    }


    #topics ol#topics-ol > li {
        display: block;
    }
    ol.numbers {
        list-style-type: decimal;
        margin: 0;
        padding: 0;
    }
    ol.letters {
        list-style-type: lower-latin;
        margin: 0;
        padding-left: 40px;
    }
    ol li span{
        font-weight: bold;
        color: #6EC9C2;
    }

    .giveSpaceContent div .con-vs-chip.vs-chip-primary.closable.con-color .text-chip .con-vs-avatar{
        height: 35px;
        width: 35px;
    }
    .faq-bg {
        background-color: #fff;
    }
    .dataTitulo{
        font-size: 12px;
        margin-top: 5px;
        color: grey;
    }
    .backLightGreen{
        background-color: #e8f7f6;
        border-radius: 25px;
    }
    .bolding{
        font-weight: 600;
    }
</style>
<style>
    .input-span-placeholder.vs-input--placeholder.large{
        padding-left: 45px !important;
        padding-top: 17px;
    }

</style>
